import axios from 'axios'
import { FileItemType } from "../types/communication/communicationDataType";
import { getBackendData, hasBackendResponseErrors } from './api';
import { AngularPhotoType } from '../types/carTypes';

export const dataURLtoFile = (dataUrl: string, filename: string): File | null => {
    if (!dataUrl) {
        return null
    }
    const arr = dataUrl.split(',');
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) throw new Error('Invalid data URL');
    const mime = mimeMatch[1];

    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}

export const uploadCreatedFileHandler = (file: File, fileType: string, token: string | undefined, onFileRemoved: Function, onFileAdded: Function) => {
    const formData = new FormData();
    formData.append("newFile", file, file.name)
    formData.append("name", file.name);
    formData.append("file_type", fileType);
    let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/upload-attachment`;
    axios.post(requestURL, formData)
        .then((res) => {
            if (hasBackendResponseErrors(res)) {
                throw new Error(`Error uploading file ${file.name}`)
            } else {
                const upF = getBackendData(res);
                const uploadedFile = new FileItemType(upF)
                uploadedFile.metadata.isLoading = false;
                return onFileAdded(uploadedFile)
            }
        })
        .catch((err) => {
            // inform the user
            console.error("Errore durante l'upload:", err);
            return onFileRemoved(file)
        });
}

/* istanbul ignore next */
export const uploadExecutionHandler = (event: any, fileType: string, token: string | undefined, onFileRemoved: Function, onFileAdded: Function, additionalBeInfo?: any) => {
    const file = event.target.files[0];
    event.target.value = null;  //clear input cache
    if (!file) return;
    file.filename = file.name
    const _file = new FileItemType(file)
    _file.metadata.isLoading = true;
    onFileAdded(_file)
    // upload file
    const formData = new FormData();
    formData.append(
        "newFile",
        file,
        file.name
    )
    // formData.append("widget_id", this.props.id);
    formData.append("name", file.name);
    if (typeof file.type !== "undefined") {
        formData.append("file_type", fileType);
    }

    if (additionalBeInfo) {
        for (const [key, value] of Object.entries(additionalBeInfo)) {
            formData.append(key, value as string);
        }
    }
    let requestURL = `${window.REACT_APP_VTV_API_ENDPOINT}/api/realtime/communication/${token}/upload-attachment`;
    axios.post(requestURL, formData)
        .then((res) => {
            if (hasBackendResponseErrors(res)) {
                throw new Error(`Error uploading file ${file.name}`)
            } else {
                const upF = getBackendData(res);
                const uploadedFile = new FileItemType(upF)
                uploadedFile.metadata.isLoading = false;
                //console.log(uploadedFile)
                onFileAdded(uploadedFile)
            }
        })
        .catch((err) => {
            // inform the user
            console.error(err)
            onFileRemoved(_file)
        });
}

export const customLabel = (filesLength?: number, textLabel?: string) => {
    if (filesLength && filesLength !== 0) return "";
    return textLabel;
}
export const computeNextPhotoIndex = (fotoAngolareVeicolo: FileItemType[], ITEMS_ANGOLARI: AngularPhotoType[]): number => {
    if (!fotoAngolareVeicolo?.length || !ITEMS_ANGOLARI?.length) {
        return 0
    }

    for (let i = 0; i < ITEMS_ANGOLARI.length; i++) {
        const angolare = ITEMS_ANGOLARI[i];
        const found = fotoAngolareVeicolo.find(foto => foto.additionalBeInfo?.detailCode === angolare?.code);
        if (!found) {
            return i;
        }
    }


    return fotoAngolareVeicolo?.length
}